import { apiPath } from '../../utils/api-contants';
import { ComponentDataRequestPayloadTypes } from '../models/component-master';
import axiosClient from './axiosClient';

const componentMasterService = {
  fetchComponents: async (payload: ComponentDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_COMPONENTS_BASE_URL, { params: payload });

      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  fetchComponentsById: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.THINGS_COMPONENTS_BASE_URL}/${payload.component_id}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  addComponents: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.THINGS_COMPONENTS_BASE_URL, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        apiResponse,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  updateComponents: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(
        `${apiPath.THINGS_COMPONENTS_BASE_URL}/${payload.component_id}`,
        payload
      );
      return {
        status: 'success',
        code: apiResponse?.status,
        apiResponse,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  removeComponents: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(`${apiPath.THINGS_COMPONENTS_BASE_URL}/${payload.component_id}`);
      return {
        status: 'success',
        code: apiResponse?.status,
        apiResponse,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default componentMasterService;
